import React, { Component } from 'react'
import AnimationVictory from './AnimationVictory'

class Credits extends Component {
    render() {
        return (
            <div className="container">
                <div>
                    <div>
                        <AnimationVictory />
                    </div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        )
    }
}

export default Credits